import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { MODE_DEMO } from "../../Utils/demoMode";
import { oublierSession } from "../../Utils/session";

/**
 * Ne rend le back-office qu'a un utilisateur connecte a Firebase Auth.
 *
 * L'ancienne garde testait `localStorage.laboratory` : une valeur que
 * n'importe qui pose depuis la console du navigateur (audit, constat E6).
 * Ici c'est le SDK qui dit s'il y a une session ; rien de local n'est cru.
 * Le serveur verifie de toute facon chaque appel — cette garde evite
 * seulement d'afficher des ecrans vides a qui n'est pas connecte.
 */
export default function GardeConnexion({ children }) {
  const [etat, setEtat] = useState(MODE_DEMO ? "connecte" : "inconnu");

  useEffect(() => {
    if (MODE_DEMO) return undefined;
    const arreter = onAuthStateChanged(getAuth(), (utilisateur) => {
      // Session Firebase expiree mais laboratoire encore en local : la page
      // de connexion (Login.jsx) renvoie vers /home tant que
      // `localStorage.laboratory` existe, et cette garde renvoie vers /login.
      // Les deux se renvoyaient la page a l'infini (ecran blanc, 30/09).
      // On oublie donc ce qui reste de l'ancienne session avant de rediriger.
      if (!utilisateur) oublierSession();
      setEtat(utilisateur ? "connecte" : "deconnecte");
    });
    return () => arreter();
  }, []);

  if (etat === "inconnu") return null;
  if (etat === "deconnecte") return <Redirect push to="/login" />;
  return <>{children}</>;
}
